/*
 *
 * OperationPayToCardDetail
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 19-Oct-2026
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  firstName: <PortalMessage id='t.app.paytocard.request.other.info.customerName' defaultMessage='Name' />,
  lastName: <PortalMessage id='t.app.paytocard.wizard.customerInfo.labels.surname' defaultMessage='Surname' />,
  email: <PortalMessage id='t.app.orders.customer.cardHolderEmail' defaultMessage='Email' />,
  phoneNumber: <PortalMessage id='t.app.paytocard.request.mobilePhone' defaultMessage='Phone number' />
}

export default formattedMessage
